import {styled, TableRow} from "@mui/material";
import theme2 from "../lib/theme";

const TableFooterRow = styled(TableRow)(({ theme }) => ({
    'td': {backgroundColor: theme2.palette.primary.main, color: theme2.palette.primary.contrastText, fontWeight: 'bold'}
}));

export default TableFooterRow;
